<script setup lang="ts">
import {CheckCircle, Clock3, Users} from "lucide-vue-next";

import "@/assets/styles/about.css";

import aboutImg from "@/assets/images/about-garden.png";
</script>

<template>

  <section class="about-section" id="about">

    <div class="about-container">

      <!-- Bild -->
      <div class="about-image">
        <img :src="aboutImg" alt="Gartenbau Team"/>
      </div>

      <!-- Content -->
      <div class="about-content">

        <span class="section-badge">
          Über uns
        </span>

        <h2>
          Garten- & Landschaftsbau<br/>
          mit Erfahrung und Leidenschaft
        </h2>

        <p>
          Wir gestalten moderne Außenanlagen,
          pflegen Gärten und schaffen individuelle Lösungen
          für private sowie gewerbliche Kunden.
        </p>

        <p>
          Qualität, Zuverlässigkeit und saubere Arbeit
          stehen bei uns an erster Stelle.
        </p>

        <!-- Vorteile -->
        <div class="about-features">

          <div class="feature-item">
            <CheckCircle/>
            Persönliche Beratung
          </div>

          <div class="feature-item">
            <CheckCircle/>
            Zuverlässige Umsetzung
          </div>

          <div class="feature-item">
            <CheckCircle/>
            Individuelle Gartenkonzepte
          </div>

        </div>

      </div>

    </div>

    <!-- Team -->
    <div class="team-section">

      <div class="team-card">

        <div class="team-icon">
          <Users/>
        </div>

        <h3>Günther Gärtner</h3>

        <span>
          Garten- & Landschaftsbau
        </span>

        <p>
          „Wir möchten Außenbereiche schaffen,
          in denen sich Menschen wirklich wohlfühlen.“
        </p>

      </div>

      <!-- Öffnungszeiten -->
      <div class="opening-card">

        <div class="team-icon">
          <Clock3/>
        </div>

        <h3>Erreichbarkeit</h3>

        <ul>
          <li>
            <span>Montag – Freitag</span>
            <span>08:00 – 17:00</span>
          </li>

          <li>
            <span>Wochenende</span>
            <span>geschlossen</span>
          </li>
        </ul>

      </div>

    </div>

  </section>

</template>

<style scoped>
</style>